import { Component, ErrorHandler, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { UserService } from '../../../../shared/user.service';
declare const $: any;

@Component({
  selector: 'app-vender-from',
  templateUrl: './vender-from.component.html',
  styleUrls: ['./vender-from.component.css']
})
export class VenderFromComponent implements OnInit {
  title="Vendors";
  data: any = {};
  c: any = {};
  d: any = {};
  s: any = {};
  n: any = {};
  Districtlist: any = {};
  Statelist: any = {};
  CATEGORYlist: any = {};
  formInvalid: boolean = false;
  mode : string;
  DOC_NOs: any;
  hide: boolean;

  constructor(private UserService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) {  }

  ngOnInit() {


debugger
 
    this.route.params.subscribe(params => {
      
      this.DOC_NOs = params['DOC_NOs'];
      this.mode = params['mode'];

      if (this.DOC_NOs > 0) {
        this.GetByIdVendor(this.DOC_NOs)
      }
      if (this.mode == 'View') {
        this.hide = true;

      }
     else if (this.mode == 'Edit') {
      this.hide = true;
    }
    });
  this.GetAllData();
  this.c.COUNTRY='INDIA'

  if(this.mode=='View'){
    this.title = "View Vendor ";
  }
  else if(this.mode=='Edit'){
    this.title = "Edit Vendor ";
  }  
}

  GetAllData() {
    debugger;

    this.data = this.UserService.GetAllDistricts();
    this.data.subscribe(
      (response: any) => {
        this.Districtlist = response.Result;
        console.log("district");
        console.log(this.Districtlist)
      })

    this.data = this.UserService.GetAllStatelist();
    this.data.subscribe(
      (response: any) => {
        this.Statelist = response.Result;
        console.log("state");
        console.log(this.Statelist)
      })

      this.data = this.UserService.GetAllCategorylist();
    this.data.subscribe(
      (response: any) => {
        this.CATEGORYlist = response.Result;
        console.log("category");
        console.log(this.CATEGORYlist)
      })


 }


 SaveVendor(Vendor: NgForm) {

  if (Vendor.invalid) {
    this.formInvalid = true;
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }

  else {

   // Vendor.value.Company_Logo_Path = this.getFeasibilityFUrlAdhara();
    this.data = this.UserService.PostVendor(Vendor.value);
    this.data.subscribe(
      (response) => {
        Vendor.reset();
        Vendor.resetForm();
        Vendor.form.markAsPristine();
        Vendor.form.markAsUntouched();
        swal('Success!', 'Vendor  Details Added Successfully .', 'success');
        this.router.navigate(['/home/manage']);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401 || error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });

    } 
  }

      GetByIdVendor(DOC_NOs){
       // this.DOC_NOs=DOC_NO;      
        document.getElementById('loader-spinner').style.display = "block";
            this.data = this.UserService.GetByIdVendor(DOC_NOs);
            this.data.subscribe(
              (response: any) => {
                this.c = response;    
                console.log(this.c)    
                    
                document.getElementById('loader-spinner').style.display = "none";
              },(error) => {
                document.getElementById('loader-spinner').style.display = "none";
                if (error.status == 401 || error.status == 500) {
                  this.errorHandler.handleError(error);
                }
                else if (error.status == 400) {
                  swal('Warning!', error.error.Message, 'warning');
                }
              });
    
              
      }


      UpdateVendor(Vendor: NgForm) {

        //Associate.value.AdressModel = this.AdressDetails;
      //  Associate.value.BankModel = this.bankDetails;
        this.data = this.UserService.UpdateVendor(Vendor.value, this.DOC_NOs);
        this.data.subscribe(
          (response) => {
           // data.reset();
            //data.resetForm();
           // data.form.markAsPristine();
           // data.form.markAsUntouched();
    
            swal('Success!', 'Vendor deatails updated Successfully .', 'success');
            document.getElementById('loader-spinner').style.display = "none";
            this.router.navigate(['/home/manage']);
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401 || error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
    



      Cancel() {
        debugger;
        this.router.navigate(['/home/manage/vendor-form']);
      }




  
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/vender/vender-from/vender-from.component.ts